import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import {useTranslation} from 'react-i18next';
import {Box, useTheme} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  yesButton?: string;
  warn?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  yesButton,
  warn
}) => {
  const {t} = useTranslation();
  const theme = useTheme();

  const confirmButtonText = yesButton || t('confirm');

  return (
    <Dialog open={open} onClose={onCancel}>
      {warn && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          mt={2}
          mb={1}
        >
          <WarningAmberIcon
            sx={{fontSize: 40, color: theme.palette.warning.dark}}
          />
        </Box>
      )}

      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          paddingBottom: 2
        }}
      >
        <Button
          onClick={onCancel}
          sx={{
            color: theme.palette.text.primary
          }}
        >
          {t('cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          variant={warn ? 'contained' : 'text'}
          sx={{
            backgroundColor: warn ? theme.palette.warning.dark : 'transparent',
            color: warn
              ? theme.palette.warning.contrastText
              : theme.palette.text.primary
          }}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
